import clsx from "clsx";
import React from "react";
import PropTypes from "prop-types";
import { Line } from "react-chartjs-2";
import styles from "./LineChart.scss";
import "chartjs-plugin-datalabels";
import { lineOptions } from "./Constant";

const propTypes = {
  /**
   * Data containing complete object for line chart.
   */
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string),
    datasets: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        data: PropTypes.arrayOf(PropTypes.number),
        fill: PropTypes.bool,
        backgroundColor: PropTypes.string,
        borderColor: PropTypes.string,
        pointRadius: PropTypes.number,
      })
    ),
  }).isRequired,
  /**
   * Heading Label for line chart.
   */
  heading: PropTypes.string,
};

const defaultProps = {
  heading: "",
};

function LineChart(props) {
  const { data, heading } = props;

  return (
    <div className={clsx(styles.base)}>
      <div className={clsx(styles.inner_div)}>
        <h6>{heading}</h6>
        <div className={clsx(styles.labels_div)}>
          {data?.datasets?.map((item) => (
            <div key={item?.label} className={clsx(styles.label_sub_div)}>
              <div
                className={clsx(styles.dot)}
                style={{ backgroundColor: item?.borderColor }}
              />
              <span className={clsx(styles.label_text)}>{item?.label}</span>
            </div>
          ))}
        </div>
      </div>
      <div className={clsx(styles.chart_div)}>
        <Line
          className={clsx(styles.chart)}
          options={lineOptions}
          data={data}
        />
      </div>
    </div>
  );
}

LineChart.propTypes = propTypes;
LineChart.defaultProps = defaultProps;

export default LineChart;
